import React from 'react'

import { Dialog, Text, Button } from "@ui-component-library"

export default function UpdatePropsModal({
    isOpen,
    displayProps,
    actionStatus,
    onRegenerateProp,
    onRefuseProp,
    onClose,
    getOldVersionDate,
}) {
    return (
        <Dialog isOpen={isOpen}>
            <Dialog.Header className="justify-between items-center">
                <Text variant="text-lg/leading-normal/medium">
                    Ny skogsbruksplan
                </Text>
            </Dialog.Header>
            <Dialog.Content>
                <Text variant="text-base/leading-normal/normal" className="mb-2">
                    Det finns en ny skogsbruksplan tillgänglig.<br /> Om du gjort ändringar på nuvarade plan kommer dessa att försvinna.
                </Text>
                <div className="mt-4 flex flex-col gap-2">
                    {displayProps.map((p) => {
                        const oldVersionDate = getOldVersionDate(p)
                        const status = actionStatus[String(p.ref)]
                        const isUpdated = status === 'updated'
                        const isRegenerated = status === 'regenerated'
                        const isRefused = status === 'refused'
                        const isBusy = status === 'updating' || status === 'refusing' || status === 'regenerating'
                        const isDisabled = isUpdated || isRegenerated || isRefused || isBusy
                        const showActions = !isUpdated && !isRegenerated && !isRefused
                        return (
                            <div
                                key={p.ref}
                                className="flex flex-col gap-2 rounded p-3 md:flex-row md:items-center md:justify-between"
                            >
                                <div>
                                    <Text variant="text-base/leading-normal/medium">
                                        {p.designation}
                                    </Text>
                                    {oldVersionDate ? (
                                        <Text variant="text-sm/leading-normal/normal" className="text-charcoal-300">
                                            Ny version: {oldVersionDate}
                                        </Text>
                                    ) : null}
                                    {isUpdated ? (
                                        <Text variant="text-sm/leading-normal/normal" className="text-green-700">
                                            Uppdatering klar
                                        </Text>
                                    ) : null}
                                    {isRefused ? (
                                        <Text variant="text-sm/leading-normal/normal" className="text-red-700">
                                            Avböjd
                                        </Text>
                                    ) : null}
                                    {status === 'error' ? (
                                        <Text variant="text-sm/leading-normal/normal" className="text-red-700">
                                            Misslyckades, försök igen
                                        </Text>
                                    ) : null}
                                </div>
                                {showActions ? (
                                    <div className="flex flex-wrap gap-2">
                                        <Button
                                            variant="primary"
                                            disabled={isDisabled}
                                            onClick={() => onRegenerateProp(p)}
                                        >
                                            {status === 'regenerating' ? "Regenererar..." : "Regenerera"}
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            disabled={isDisabled}
                                            onClick={() => onRefuseProp(p)}
                                        >
                                            {status === 'refusing' ? "Avböjer..." : "Avböj"}
                                        </Button>
                                    </div>
                                ) : null}
                            </div>
                        )
                    })}
                </div>
            </Dialog.Content>
            <Dialog.Footer>
                <div className='flex justify-end'>
                    <Button
                        onClick={onClose}
                    >
                        Stäng
                    </Button>
                </div>
        </Dialog.Footer>
        </Dialog>
    )
}
